import { LOB } from "constants/common";
import Environment from "services/environment";

const modifyPayload = (payload, lob) => {
  switch (lob) {
    case LOB.DATA:
      payload.prop0 = "b2b|data";
      break;
    case LOB.AIRTEL_CLOUD:
      payload.prop0 = "b2b|cloud";
      break;  
    case LOB.MOBILITY:
      payload.prop0 = "b2b|cocp";
      break;
    case LOB.BLUEJEANS:
      payload.prop0 = "b2b|bluejeans";
      break;
    case LOB.NXTRA:
      payload.prop0 = "b2b|nxtra";
      break;
    case LOB.TELEMEDIA:
      payload.prop0 = "b2b|telemedia";
      break;
    default:
      payload.prop0 = "b2b|selfcare";
      break;
  }
  payload.eventCategory = payload.eVar0;
  return payload;
};

export const trackAnalytics = (data, lob) => {
  const env = Environment.getEnv();
  try {
    if (!data) {
      console.error("No data found for analytics");
      return;
    }
    if (typeof window.ClickStream !== "undefined") {
      const analyticsPayload = modifyPayload(data, lob);
      window.ClickStream.trackEvent(analyticsPayload);
      if (env.appEnv !== "PROD") {
        console.log("b2b-ui-components-lib analytics", analyticsPayload);
      }
    }
  } catch (error) {
    console.log(error);
  }
};
